import React from "react";

import ManagedPortalHome from "screens/ManagedPortalHome";

export default function MVUAcceleratorHome() {
    return <ManagedPortalHome portal="accelerator" />;
}
